export const ITEMS_PER_PAGE_OPTIONS = {
    TEN: 10,
    TWENTY_FIVE: 25,
    HUNDRED: 100,
    TWO_HUNDRED: 200,
} as const;

export type ItemsPerPageOptions = typeof ITEMS_PER_PAGE_OPTIONS[keyof typeof ITEMS_PER_PAGE_OPTIONS];
